import { motion } from "framer-motion";

const ServiceCard = ({ icon: Icon, title, description, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5 }}
      data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      className="group p-4 sm:p-6 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-300"
    >
      <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-primary/20 transition-colors">
        <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
      </div>
      <h3 className="font-heading font-semibold text-base sm:text-lg text-foreground mb-1.5 sm:mb-2">
        {title}
      </h3>
      <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed">
        {description}
      </p>
    </motion.div>
  );
};

export default ServiceCard;
